import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpEvent, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { catchError, EMPTY, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { errorModal } from '../models/error-modal';
import { environment } from 'src/environments/environment';
import { CacheService } from '../services/cache.service';
import { ApplicationService } from '../services/application.service';
import { LoadingService } from '../services/loading-service';
import { AppConfigService } from '../services/app-config.service';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root',
})
export class ErrorInterceptor {
  GenericErrorTextMsg: string = "";
  ForbiddenErrorTextMsg: string = "";

  constructor(
    private readonly applicationService: ApplicationService,
    private readonly _loading: LoadingService,
    private readonly _appConfig: AppConfigService,
    private readonly _cacheService: CacheService,
    private readonly _router: Router,
  ) {}



  private errorModalLaunch: errorModal = {
    errorLevel: '',
    respCode: '',
    respDesc: '',
  };

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (event.body) {
            event = event.clone({ body: this.modifyBody(event.body, req) });
          }
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        console.log('ErrorInterceptor caught an error:', error);
        this._loading.setLoading(false, req.url);

        // --- Explicit 401 (Unauthorized) handling ---
        // Token is missing / invalid / expired. Wipe session state and
        // send the user back to the login flow
        if (error?.status === 401) {
          console.warn('ErrorInterceptor: 401 Unauthorized detected. Redirecting to login.');
          this.handleUnauthorized();
          return EMPTY;
        }

        if (error != null && error.status != undefined) {

          const cfg = this._appConfig.getAppConfig();
          let statusText = error.error.title;
          if(statusText == null || statusText == undefined || statusText == '') {
            statusText = cfg.GenericErrorTextMsg
          }
          if (statusText == 'Forbidden' || error.status == 403) {
            statusText = cfg.ForbiddenErrorTextMsg;
          }
          this.errorModalLaunch.errorLevel = error.status.toString();
          this.errorModalLaunch.respDesc = statusText;
          this.applicationService.broadcastErrorModalLaunch(
            this.errorModalLaunch
          );
        }
        return of(EMPTY);
      })
    );
  }

  /**
 * Clears cached auth state and routes the user back to the login page.
 * Used when the API rejects a request with 401 Unauthorized, typically
 * because the bearer token has expired.
 */
  private handleUnauthorized(): void {
    this._cacheService.cleanLocalStorage();
    this._cacheService.cleanSessionStorage();
    history.replaceState({}, '');
    window.location.assign('/login');
  }

  private modifyBody(body: any, request: any) {
    if (
      request.url == `${environment.PplAppsApi}/Customer/register` &&
      body.applicationDetails.customerMessage == null &&
      body.applicationDetails.customerMessage2 != null &&
      body.respCode == 1
    ) {
    } else if (
      body.respCode != undefined &&
      body.respCode != '0' &&
      body.respCode != ''
    ) {
      this.errorModalLaunch.respCode = body.respCode;
      if (
        body.applicationDetail != null &&
        body.applicationDetail.customerMsg != null
      ) {
        this.errorModalLaunch.respDesc = body.applicationDetail.customerMsg;
      } else {
        this.errorModalLaunch.respDesc = body.respDesc;
      }
      this.applicationService.broadcastErrorModalLaunch(this.errorModalLaunch);
    } else if (
      body.applicationDetail == null &&
      body.applicationDetails == null &&
      body.respCode == '0'
    ) {
      this.errorModalLaunch.respCode = '-1';
      this.errorModalLaunch.respDesc = 'Oops! Something went wrong.';
      this.applicationService.broadcastErrorModalLaunch(this.errorModalLaunch);
    }
  }
}
